import React, { useEffect } from 'react';
import ContactUsCard from '../../Components/ContactUsCard/ContactUsCard';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgContactStage from '../../assets/ContactLocation/contact us.jpg';

import imgBeogradZemun from '../../assets/ContactLocation/Beograd-Zemun.png';
import imgBeogradŽeleznik from '../../assets/ContactLocation/Beograd-Zeleznik.png';
import imgBeogradLeštane from '../../assets/ContactLocation/Beograd-Lestane.png';
import imgKragujevac from '../../assets/ContactLocation/Kragujevac.png';
import imgNiš from '../../assets/ContactLocation/Nis.png';
import imgNoviSad from '../../assets/ContactLocation/NoviSad.png';
import imgSubotica from '../../assets/ContactLocation/Subotica.png';
import imgValjevo from '../../assets/ContactLocation/Valjevo.png';
import imgUžice from '../../assets/ContactLocation/Uzice.png';
import imgCylinderCenter from '../../assets/ContactLocation/CylinderCenter.png';

const ContactUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const units = [
        
                {
            name: 'HANSA-FLEX Hidraulika d.o.o.',
            location: 'HANSA-FLEX Beograd-Železnik, Lole Ribara 120, 11250 Beograd-Železnik, Serbia',
            telephone: '+381 11 2577 662',
            telephone2: '+381 11 2571 062',
            telephone3: '+381 11 2589 663',
            mail: 'srz@hansa-flex.com',
            mail2: 'info.srb@hansa-flex.com',
            service24h: '+381 65 2442 678',
            flexpress24h: '',
            coordinates: '44.73124002139356, 20.366806977192333',
            image: imgBeogradŽeleznik,
            type: 'headquarters',
        },
        {
            name: 'HANSA-FLEX Beograd-Zemun',
            location: 'HANSA-FLEX Beograd-Zemun, Psačka 32, 11185 Beograd-Zemun, Serbia',
            telephone: '+381 11 4018 079',
            telephone2: '+381 11 4033 247',
            telephone3: '+381 11 4033 248',
            mail: 'srb@hansa-flex.com',
            service24h: '+381 65 2442 661',
            flexpress24h: '+381 65 2442 660',
            coordinates: '44.881254023655316, 20.316305957227982',
            image: imgBeogradZemun, // Replace with actual image import if needed
            type: 'subsidiaries',
        },

        {
            name: 'HANSA-FLEX Beograd-Leštane',
            location: 'HANSA-FLEX Beograd-Leštane, Smederevski put 29A, 11309 Beograd-Leštane, Serbia',
            telephone: '+381 11 8036 591',
            telephone2: '',
            telephone3: '',
            mail: 'srl@hansa-flex.com',
            service24h: '+381 65 2442 620',
            flexpress24h: '',
            coordinates: '44.74796893181252, 20.590829609745303',
            image: imgBeogradLeštane,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Kragujevac',
            location: 'HANSA-FLEX Kragujevac, Miodraga Vlajića Šuke 18, 34000 Kragujevac, Serbia',
            telephone: '+381 34 3569 50',
            telephone2: '+381 34 6100 277',
            telephone3: '',
            mail: 'srk@hansa-flex.com',
            service24h: '+381 65 2442 659',
            flexpress24h: '',
            coordinates: '44.02322542576461, 20.93028876896603',
            image: imgKragujevac,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Niš',
            location: 'HANSA-FLEX Niš, Bulevar 12. Februara 119, 18000 Niš, Serbia',
            telephone: '+381 18 5819 20',
            telephone2: '',
            telephone3: '',
            mail: 'srn@hansa-flex.com',
            service24h: '+381 65 2442 673',
            flexpress24h: '',
            coordinates: '43.34236425725847, 21.870262188709265',
            image: imgNiš,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Novi Sad',
            location: 'HANSA-FLEX Novi Sad, Sonje Marinković 1b, 21203 Veternik, Serbia',
            telephone: '+381 21 824 605',
            telephone2: '+381 21 302 3070',
            telephone3: '',
            mail: 'srs@hansa-flex.com',
            service24h: '+381 65 2442 675',
            flexpress24h: '',
            coordinates: '45.24848728679945, 19.76282666482308',
            image: imgNoviSad,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Subotica',
            location: 'HANSA-FLEX Subotica, Franje Kluza 17, 24000 Subotica, Serbia',
            telephone: '+381 24 5599 45',
            telephone2: '',
            telephone3: '',
            mail: 'sub@hansa-flex.com',
            service24h: '+381 65 2443 244',
            flexpress24h: '',
            coordinates: '46.08733897580099, 19.64276917347836',
            image: imgSubotica,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Valjevo',
            location: 'HANSA-FLEX Valjevo, Dr. Gordane Babić 27, 14000 Valjevo, Serbia',
            telephone: '+381 14 3101 409',
            telephone2: '',
            telephone3: '',
            mail: 'rsv@hansa-flex.com',
            service24h: '+381 65 2442 688',
            flexpress24h: '',
            coordinates: '44.27674927879604, 19.926820607745746',
            image: imgValjevo,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Užice',
            location: 'HANSA-FLEX Užice, Banjička 22, 31000 Užice, Serbia',
            telephone: '+381 31 6040 98',
            telephone2: '',
            telephone3: '',
            mail: 'sru@hansa-flex.com',
            service24h: '+381 65 2443 257',
            flexpress24h: '',
            coordinates: '43.84726171891286, 19.854908345781517',
            image: imgUžice,
            type: 'subsidiaries',
        },
        {
            name: 'HANSA-FLEX Cylinder Center',
            location: 'HANSA-FLEX Cylinder Center, Psačka 32, 11185 Beograd-Zemun, Serbia',
            telephone: '+381 11 4018 079',
            telephone2: '+381 11 4033 247',
            telephone3: '+381 11 4033 248',
            mail: 'a.vuckovic@hansa-flex.com',
            service24h: '+381 64 169 3682',
            flexpress24h: '',
            coordinates: '44.881254023655316, 20.316305957227982',
            image: imgCylinderCenter,
            type: 'division',
        },
        // {
        //     image:imgCylinderCenter,
        //     name:'HANSA-FLEX',
        //     location:'',
        //     telephone:'',
        //     telephone2:'',
        //     mail:'',
        //     type:'division',
        // }
    ];


    return (
        <div className="">
            <div>
                <CenterStage
                    imageSrc={imgContactStage}
                    title={"Get in Touch with HANSA-FLEX Serbia"}
                    paragraph={"We're here to assist you with all your hydraulic needs. Whether you have inquiries about our products, require technical support, or wish to explore partnership opportunities, our team is ready to help. Contact us today and experience the reliability and expertise that define HANSA-FLEX Serbia."} />
            </div>
            <div className=''>
                <ContactUsCard units={units} />
            </div>
        </div>
    );
};

export default ContactUs;
